/* Giftationery – sticky Add to cart bar for mobile product pages.
   The bar appears when the real Add to cart button is scrolled out of view.
   Tapping it scrolls to the first empty required personalisation field;
   if all fields are filled, it clicks the real Add to cart button. */
(function () {
  function init() {
    var info = document.querySelector('product-info[id^="MainProduct-"]');
    if (!info) return;
    var realBtn = info.querySelector('.product-form__submit');
    if (!realBtn || !('IntersectionObserver' in window)) return;

    var bar = document.createElement('div');
    bar.className = 'gft-sticky-atc';
    bar.setAttribute('aria-hidden', 'true');
    bar.innerHTML =
      '<div class="gft-sticky-atc__price"></div>' +
      '<button type="button" class="gft-sticky-atc__btn" tabindex="-1"></button>';
    document.body.appendChild(bar);

    var priceBox = bar.querySelector('.gft-sticky-atc__price');
    var btn = bar.querySelector('.gft-sticky-atc__btn');

    function refresh() {
      var sale = info.querySelector('.price--on-sale .price-item--sale');
      var regular = info.querySelector('.price__regular .price-item--regular');
      var priceEl = sale || regular;
      priceBox.textContent = priceEl ? priceEl.textContent.trim() : '';
      var label = realBtn.querySelector('span');
      btn.textContent = (label ? label.textContent : realBtn.textContent).trim() || 'Add to cart';
      btn.disabled = realBtn.disabled || realBtn.getAttribute('aria-disabled') === 'true';
    }

    function firstEmptyRequired() {
      var fields = info.querySelectorAll('input[required], textarea[required], select[required]');
      for (var i = 0; i < fields.length; i++) {
        var f = fields[i];
        if (f.type === 'hidden' || f.offsetParent === null) continue;
        if (f.type === 'radio' || f.type === 'checkbox') {
          if (!info.querySelector('input[name="' + f.name + '"]:checked')) return f;
        } else if (!f.value || !f.value.trim()) {
          return f;
        }
      }
      return null;
    }

    btn.addEventListener('click', function () {
      var empty = firstEmptyRequired();
      if (empty) {
        empty.scrollIntoView({ behavior: 'smooth', block: 'center' });
        setTimeout(function () {
          try { empty.focus({ preventScroll: true }); } catch (e) { empty.focus(); }
        }, 400);
        return;
      }
      realBtn.scrollIntoView({ behavior: 'smooth', block: 'center' });
      realBtn.click();
    });

    var observer = new IntersectionObserver(function (entries) {
      var visible = entries[0].isIntersecting;
      refresh();
      bar.classList.toggle('is-visible', !visible);
      document.body.classList.toggle('gft-has-sticky-atc', !visible);
    });
    observer.observe(realBtn);

    // Keep price/label in sync when the customer changes a variant
    document.addEventListener('change', function () { setTimeout(refresh, 300); });
    refresh();
  }

  /* Trust strip under the Add to cart button */
  function addTrustStrip() {
    var info = document.querySelector('product-info[id^="MainProduct-"]');
    if (!info || info.querySelector('.gft-trust')) return;
    var buttons = info.querySelector('.product-form__buttons');
    if (!buttons) return;
    var icon = function (path) {
      return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' + path + '</svg>';
    };
    var strip = document.createElement('div');
    strip.className = 'gft-trust';
    strip.innerHTML =
      '<div class="gft-trust__item">' + icon('<path d="M3 7h11v9H3z"/><path d="M14 10h4l3 3v3h-7"/><circle cx="7" cy="18" r="1.6"/><circle cx="17" cy="18" r="1.6"/>') + '<span>Ships in 24 hours</span></div>' +
      '<div class="gft-trust__item">' + icon('<path d="M12 21s-7-4.4-7-10a4 4 0 0 1 7-2.6A4 4 0 0 1 19 11c0 5.6-7 10-7 10z"/>') + '<span>Handcrafted with love</span></div>' +
      '<div class="gft-trust__item">' + icon('<path d="M12 21s-6-5.3-6-11a6 6 0 0 1 12 0c0 5.7-6 11-6 11z"/><circle cx="12" cy="10" r="2.2"/>') + '<span>Pan-India delivery</span></div>';
    buttons.parentNode.insertBefore(strip, buttons.nextSibling);
  }

  /* Product cards: replace the plain "Sale" badge with the real "% OFF" */
  function percentBadges(root) {
    var cards = (root || document).querySelectorAll('.card-wrapper');
    var toNum = function (el) {
      return el ? parseFloat(el.textContent.replace(/[^0-9.]/g, '').replace(/^\./, '')) : NaN;
    };
    cards.forEach(function (card) {
      var badges = card.querySelectorAll('.card__badge .badge');
      if (!badges.length || card.dataset.gftDone) return;
      var price = card.querySelector('.price--on-sale');
      if (!price) return;
      var sale = toNum(price.querySelector('.price-item--sale'));
      var mrp = toNum(price.querySelector('.price__sale s .price-item--regular, .price__sale .price-item--regular'));
      if (sale > 0 && mrp > sale) {
        var label = Math.round((1 - sale / mrp) * 100) + '% OFF';
        badges.forEach(function (b) { b.textContent = label; });
        card.dataset.gftDone = '1';
      }
    });
  }

  /* FAQ: split the single rich-text block ("Q: ... A: ...") into separate expandable cards */
  function enhanceFaq() {
    var section = document.querySelector('[id*="product_faq_section"]');
    if (!section || section.querySelector('.gft-faq')) return;
    var accordion = section.querySelector('.product__accordion');
    var content = accordion && accordion.querySelector('.accordion__content');
    if (!content) return;

    var items = [];
    var current = null;
    Array.prototype.forEach.call(content.childNodes, function (node) {
      var text = (node.textContent || '').trim();
      var isQuestion = node.nodeType === 1 && /^(STRONG|B)$/.test(node.tagName) && /^Q\s*[:.\-]/i.test(text);
      if (isQuestion) {
        current = { q: text.replace(/^Q\s*[:.\-]\s*/i, ''), a: document.createElement('div') };
        items.push(current);
      } else if (current) {
        current.a.appendChild(node.cloneNode(true));
      }
    });
    items = items.filter(function (it) { return it.q && it.a.textContent.trim(); });
    if (items.length < 2) return;

    var titleEl = accordion.querySelector('.accordion__title');
    var title = titleEl ? titleEl.textContent.trim() : 'Frequently Asked Questions';

    var wrap = document.createElement('div');
    wrap.className = 'gft-faq';
    wrap.innerHTML =
      '<div class="gft-faq__head"><span class="gft-faq__eyebrow">Got questions?</span>' +
      '<h2 class="gft-faq__title"></h2><p class="gft-faq__sub">Everything you need to know before you order.</p></div>' +
      '<div class="gft-faq__list"></div>';
    wrap.querySelector('.gft-faq__title').textContent = title;
    var list = wrap.querySelector('.gft-faq__list');

    var schema = [];
    items.forEach(function (it, i) {
      // tidy the answer: drop leading "A:" and stray line breaks
      var a = it.a;
      while (a.firstChild && (a.firstChild.nodeName === 'BR' || (a.firstChild.nodeType === 3 && !a.firstChild.textContent.trim()))) a.removeChild(a.firstChild);
      while (a.lastChild && (a.lastChild.nodeName === 'BR' || (a.lastChild.nodeType === 3 && !a.lastChild.textContent.trim()))) a.removeChild(a.lastChild);
      if (a.firstChild && a.firstChild.nodeType === 3) a.firstChild.textContent = a.firstChild.textContent.replace(/^\s*A\s*[:.\-]\s*/i, '');

      var d = document.createElement('details');
      d.className = 'gft-faq__item';
      if (i === 0) d.open = true;
      var sum = document.createElement('summary');
      sum.className = 'gft-faq__q';
      sum.innerHTML = '<span class="gft-faq__num"></span><span class="gft-faq__text"></span><span class="gft-faq__icon" aria-hidden="true"></span>';
      sum.querySelector('.gft-faq__num').textContent = (i + 1 < 10 ? '0' : '') + (i + 1);
      sum.querySelector('.gft-faq__text').textContent = it.q;
      a.className = 'gft-faq__a rte';
      d.appendChild(sum);
      d.appendChild(a);
      list.appendChild(d);
      schema.push({ '@type': 'Question', name: it.q, acceptedAnswer: { '@type': 'Answer', text: a.textContent.trim() } });
    });

    accordion.parentNode.insertBefore(wrap, accordion);
    section.classList.add('gft-faq-ready');

    // FAQ structured data for Google (only if the page has none yet)
    var hasFaqSchema = Array.prototype.some.call(document.querySelectorAll('script[type="application/ld+json"]'), function (sc) {
      return sc.textContent.indexOf('FAQPage') !== -1;
    });
    if (!hasFaqSchema) {
      var ld = document.createElement('script');
      ld.type = 'application/ld+json';
      ld.textContent = JSON.stringify({ '@context': 'https://schema.org', '@type': 'FAQPage', mainEntity: schema });
      document.head.appendChild(ld);
    }
  }

  /* Specifications: turn "Label: value" lines into a clean two-column table */
  function enhanceSpecs() {
    document.querySelectorAll('.specifications-content').forEach(function (box) {
      if (box.querySelector('.gft-specs')) return;
      var rows = [];
      var label = null;
      var value = '';
      var flush = function () {
        if (label) rows.push([label, value.replace(/^\s*[:\-]\s*/, '').trim()]);
        label = null;
        value = '';
      };
      var walk = function (parent) {
        Array.prototype.forEach.call(parent.childNodes, function (node) {
          if (node.nodeType === 1 && /^(STRONG|B)$/.test(node.tagName)) {
            flush();
            label = node.textContent.replace(/:\s*$/, '').trim();
          } else if (node.nodeType === 1 && node.tagName === 'BR') {
            flush();
          } else if (node.nodeType === 1 && /^(P|LI)$/.test(node.tagName)) {
            flush();
            walk(node);
            flush();
          } else if (label !== null) {
            value += node.textContent;
          } else if (node.nodeType === 1 && node.children.length) {
            walk(node);
          }
        });
      };
      walk(box);
      flush();
      rows = rows.filter(function (r) { return r[0] && r[1]; });
      if (rows.length < 2) return;
      var dl = document.createElement('dl');
      dl.className = 'gft-specs';
      rows.forEach(function (r) {
        var row = document.createElement('div');
        row.className = 'gft-specs__row';
        var dt = document.createElement('dt');
        dt.textContent = r[0];
        var dd = document.createElement('dd');
        dd.textContent = r[1];
        row.appendChild(dt);
        row.appendChild(dd);
        dl.appendChild(row);
      });
      box.insertBefore(dl, box.firstChild);
      box.classList.add('gft-specs-ready');
    });
  }

  function start() {
    init();
    addTrustStrip();
    percentBadges();
    enhanceFaq();
    enhanceSpecs();
    // Collection filters / infinite loads replace the grid, so re-run on changes
    var grid = document.getElementById('ProductGridContainer') || document.querySelector('.product-grid-container');
    if (grid && 'MutationObserver' in window) {
      new MutationObserver(function () { percentBadges(grid); }).observe(grid, { childList: true, subtree: true });
    }
    var related = document.querySelector('product-recommendations');
    if (related && 'MutationObserver' in window) {
      new MutationObserver(function () { percentBadges(related); }).observe(related, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();

/* Giftationery – cart page polish (empty state, item cards, order summary) */
(function () {
  /* ---------------- CART PAGE ---------------- */
  var cartIcon = function (path) {
    return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' + path + '</svg>';
  };

  /* Personalised items showed their details twice (custom block + Dawn's list) */
  function dedupeCartProperties(root) {
    root.querySelectorAll('.cart-item').forEach(function (row) {
      var custom = row.querySelector('.cart-item__properties');
      if (!custom) return;
      var labels = {};
      custom.querySelectorAll('strong').forEach(function (st) {
        labels[st.textContent.replace(/:\s*$/, '').trim().toLowerCase()] = true;
      });
      row.querySelectorAll('dl .product-option').forEach(function (opt) {
        var dt = opt.querySelector('dt');
        if (dt && opt.style.display !== 'none' && labels[dt.textContent.replace(/:\s*$/, '').trim().toLowerCase()]) opt.style.display = 'none';
      });
    });
  }

  /* Friendly empty-cart state */
  function enhanceEmptyCart(root) {
    var warn = root.querySelector('.cart__warnings');
    if (!warn || warn.querySelector('.gft-empty__icon')) return;
    var heading = warn.querySelector('.cart__empty-text');
    if (!heading) return;
    var iconWrap = document.createElement('div');
    iconWrap.className = 'gft-empty__icon';
    iconWrap.innerHTML = cartIcon('<path d="M6 8h12l-1 12H7L6 8z"/><path d="M9 8V6a3 3 0 0 1 6 0v2"/><path d="M12 12.5c-.9-1.1-2.7-.6-2.7.8 0 1.4 2.7 2.9 2.7 2.9s2.7-1.5 2.7-2.9c0-1.4-1.8-1.9-2.7-.8z"/>');
    heading.parentNode.insertBefore(iconWrap, heading);
    var sub = document.createElement('p');
    sub.className = 'gft-empty__sub';
    sub.textContent = "Looks like you haven't picked a gift yet. Let's find something they'll love.";
    heading.parentNode.insertBefore(sub, heading.nextSibling);

    var btn = warn.querySelector('a.button');
    var chips = document.createElement('div');
    chips.className = 'gft-empty__chips';
    var links = [
      ['Best Sellers', '/collections/best-sellers'],
      ['New Arrivals', '/collections/new-arrivals'],
      ['LED Lamps', '/collections/led-3d-lamps'],
      ['Caricature Gifts', '/collections/caricature-gifts'],
      ['Desk Organizers', '/collections/desk-organizers']
    ];
    chips.innerHTML = '<span class="gft-empty__chips-label">Popular right now</span>';
    links.forEach(function (l) {
      var a = document.createElement('a');
      a.className = 'gft-chip';
      a.href = l[1];
      a.textContent = l[0];
      chips.appendChild(a);
    });
    if (btn) btn.parentNode.insertBefore(chips, btn.nextSibling);
    else warn.appendChild(chips);
  }

  /* Item count next to the "Your cart" title */
  function cartCount(root) {
    var title = root.querySelector('.title-wrapper-with-link .title');
    if (!title) return;
    var qty = 0;
    root.querySelectorAll('.cart-item .quantity__input').forEach(function (i) { qty += parseInt(i.value, 10) || 0; });
    var pill = title.querySelector('.gft-cart-count');
    if (!qty) { if (pill) pill.remove(); return; }
    if (!pill) {
      pill = document.createElement('span');
      pill.className = 'gft-cart-count';
      title.appendChild(pill);
    }
    var label = qty + (qty === 1 ? ' item' : ' items');
    if (pill.textContent !== label) pill.textContent = label; // avoid re-triggering the observer
  }

  /* Order summary heading + trust line under the Check out button */
  function enhanceCartFooter() {
    var blocks = document.querySelector('.cart__footer .cart__blocks');
    if (!blocks) return;
    if (!blocks.querySelector('.gft-summary__title')) {
      var h = document.createElement('h2');
      h.className = 'gft-summary__title';
      h.textContent = 'Order summary';
      blocks.insertBefore(h, blocks.firstChild);
    }
    var ctas = blocks.querySelector('.cart__ctas');
    if (ctas && !blocks.querySelector('.gft-summary__trust')) {
      var t = document.createElement('div');
      t.className = 'gft-summary__trust';
      t.innerHTML =
        '<span>' + cartIcon('<rect x="5" y="11" width="14" height="9" rx="2"/><path d="M8 11V8a4 4 0 0 1 8 0v3"/>') + 'Secure checkout</span>' +
        '<span>' + cartIcon('<path d="M3 7h11v9H3z"/><path d="M14 10h4l3 3v3h-7"/><circle cx="7" cy="18" r="1.6"/><circle cx="17" cy="18" r="1.6"/>') + 'Ships in 24 hours</span>' +
        '<span>' + cartIcon('<path d="M12 21s-6-5.3-6-11a6 6 0 0 1 12 0c0 5.7-6 11-6 11z"/><circle cx="12" cy="10" r="2.2"/>') + 'Pan-India delivery</span>';
      ctas.parentNode.insertBefore(t, ctas.nextSibling);
    }
  }

  function enhanceCart() {
    var cart = document.querySelector('cart-items');
    if (!cart) return;
    var run = function () {
      dedupeCartProperties(cart);
      enhanceEmptyCart(cart);
      cartCount(cart);
      enhanceCartFooter();
    };
    run();
    // Dawn re-renders the cart when quantities change, so re-apply afterwards
    if ('MutationObserver' in window) {
      var timer;
      var mo = new MutationObserver(function () {
        clearTimeout(timer);
        timer = setTimeout(run, 120);
      });
      mo.observe(cart, { childList: true, subtree: true });
      var footer = document.querySelector('.cart__footer');
      if (footer) mo.observe(footer.parentNode, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', enhanceCart);
  } else {
    enhanceCart();
  }
})();

/* Giftationery – collection pages polish (hero, related chips, empty state, collections list) */
(function () {
  // Fallback chips for collections that are not part of a menu group
  var FALLBACK = [
    ['Best Sellers', 'best-sellers'],
    ['New Arrivals', 'new-arrivals'],
    ['LED Lamps', 'led-3d-lamps'],
    ['Caricature Gifts', 'caricature-gifts'],
    ['Desk Organizers', 'desk-organizers'],
    ['Pen Stands', 'pen-stands-and-desk-accessories'],
    ['Coasters', 'coasters']
  ];
  // Hand-written intros for collections that do not belong to a menu group
  var INTROS = {
    'best-sellers': 'Our most-loved personalised gifts – picked again and again by customers across India.',
    'new-arrivals': 'Fresh designs, just out of the Giftationery workshop.',
    'caricature-gifts': 'Turn a photo into a fun, hand-drawn caricature gift they will never forget.',
    'led-3d-lamps': 'Glowing LED lamps engraved with names, dates and memories.',
    'name-engraved-led-lamps': 'Glowing LED lamps engraved with names, dates and memories.',
    'desk-organizers': 'Smart, personalised desk organizers that keep work tidy and stylish.',
    'pen-stands-and-desk-accessories': 'Personalised pen stands and desk accessories for every workspace.',
    'coasters': 'Hand-painted art coasters that bring colour to every cup of chai.',
    'corporate-gifts': 'Premium personalised gifts for your team and clients – with bulk pricing available.'
  };
  // Collections only used to build the home page – never shown in the public list
  var INTERNAL = /^(homepage-mix|frontpage$)/;

  var svg = function (path) {
    return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' + path + '</svg>';
  };
  var ICON_GIFT = '<rect x="3" y="9" width="18" height="12" rx="2"/><path d="M3 13h18M12 9v12"/><path d="M12 9c-2.5 0-4.5-1-4.5-3a2 2 0 0 1 4.5 0c0 2 0 3 0 3zM12 9c2.5 0 4.5-1 4.5-3a2 2 0 0 0-4.5 0c0 2 0 3 0 3z"/>';
  var ICON_TAG = '<path d="M20 12l-8 8-9-9V3h8l9 9z"/><circle cx="7.5" cy="7.5" r="1.5"/>';
  var ICON_SPARK = '<path d="M12 3v4M12 17v4M3 12h4M17 12h4M6 6l2.5 2.5M15.5 15.5L18 18M6 18l2.5-2.5M15.5 8.5L18 6"/>';
  var ICON_BOX = '<path d="M3 7l9-4 9 4-9 4-9-4z"/><path d="M3 7v10l9 4 9-4V7"/><path d="M12 11v10"/>';

  var cache = {};
  function getJSON(url) {
    if (!cache[url]) cache[url] = fetch(url).then(function (r) { return r.json(); }).catch(function () { return {}; });
    return cache[url];
  }
  function currentHandle() {
    var m = location.pathname.match(/\/collections\/([^\/?#]+)/);
    return m ? decodeURIComponent(m[1]) : '';
  }
  function clean(text) {
    return (text || '').replace(/\s+/g, ' ').trim();
  }

  /* Read the store's own menu groups (By Relation, By Occasion, ...) from the header */
  function menuGroups() {
    var groups = [];
    var header = document.querySelector('header') || document;
    header.querySelectorAll('ul').forEach(function (ul) {
      var links = Array.prototype.filter.call(ul.querySelectorAll(':scope > li > a'), function (a) {
        return /\/collections\/[^\/]+/.test(a.getAttribute('href') || '') && !/\/collections\/all\b/.test(a.getAttribute('href'));
      });
      if (links.length < 2) return;
      var li = ul.closest('li');
      var headEl = li && li.querySelector(':scope > a, :scope > span, :scope > p, :scope > h3, :scope > summary');
      var title = clean(headEl ? headEl.textContent : '');
      if (!title) return;
      groups.push({
        title: title,
        items: links.map(function (a) {
          return { name: clean(a.textContent), handle: a.getAttribute('href').split('/collections/')[1].split(/[?#\/]/)[0] };
        })
      });
    });
    return groups;
  }

  function niceGroup(title) {
    var t = title.toLowerCase().replace(/^by\s+/, '').replace(/&amp;/g, '&');
    return t.charAt(0).toUpperCase() + t.slice(1);
  }
  function joinOr(name) {
    var parts = name.split(/\s*\/\s*/);
    if (parts.length < 2) return name;
    return parts.slice(0, -1).join(', ') + ' or ' + parts[parts.length - 1];
  }

  /* Intro line, tailored to the menu group the collection sits in */
  function introFor(handle, name, group) {
    if (INTROS[handle]) return INTROS[handle];
    var lower = joinOr(name).toLowerCase().replace(/\bit\b/g, 'IT');
    var g = group ? group.title.toLowerCase() : '';
    if (/relation/.test(g)) return 'Thoughtful personalised gifts for your ' + lower + ' – made to order and shipped within 24 hours.';
    if (/occasion/.test(g)) return 'Personalised ' + lower.replace(/([^s])s$/, '$1') + ' gifts they will treasure – handcrafted and shipped within 24 hours.';
    if (/profession/.test(g)) return 'Nameplates and desk gifts made for ' + (/s$/.test(lower) ? lower : lower + 's') + ' – personalised with their name and title.';
    if (/corporate/.test(g)) return 'Premium personalised gifts for teams and clients – with bulk pricing available.';
    if (/decor/.test(g)) return 'Handcrafted décor pieces that make every corner feel personal.';
    return 'Personalised, handcrafted gifts – made just for them and shipped within 24 hours.';
  }

  function chipRow(label, items) {
    var row = document.createElement('div');
    row.className = 'gft-coll-chips';
    var lab = document.createElement('span');
    lab.className = 'gft-coll-chips__label';
    lab.textContent = label;
    var track = document.createElement('div');
    track.className = 'gft-coll-chips__track';
    items.forEach(function (it) {
      var a = document.createElement('a');
      a.className = 'gft-chip';
      a.href = '/collections/' + it.handle;
      a.textContent = it.name;
      track.appendChild(a);
    });
    row.appendChild(lab);
    row.appendChild(track);
    return row;
  }

  /* Related collections: siblings from the same menu group, without empty ones */
  function relatedFor(handle, groups, counts) {
    var group = null;
    groups.some(function (g) {
      if (g.items.some(function (it) { return it.handle === handle; })) { group = g; return true; }
      return false;
    });
    var items = group ? group.items : FALLBACK.map(function (f) { return { name: f[0], handle: f[1] }; });
    items = items.filter(function (it) {
      return it.handle !== handle && !(counts && counts[it.handle] === 0);
    });
    var label = group ? 'More gifts by ' + niceGroup(group.title).toLowerCase() : 'You may also like';
    if (group && /corporate|decor/i.test(group.title)) label = 'More in ' + niceGroup(group.title);
    return { group: group, items: items, label: label };
  }

  function countsMap() {
    return getJSON('/collections.json?limit=250').then(function (d) {
      var m = {};
      (d.collections || []).forEach(function (c) { m[c.handle] = c.products_count; });
      return m;
    });
  }

  /* Hero photo stack: the first products of the collection, each linking to its product page.
     On phones the stack can be swiped with a thumb (or a back photo tapped) to bring another to the front. */
  function photoStack(collage, pics) {
    var n = pics.length;
    var front = n > 2 ? 1 : 0;
    var cards = pics.map(function (p) {
      var a = document.createElement('a');
      a.href = '/products/' + p.handle;
      a.setAttribute('aria-label', p.title);
      var img = document.createElement('img');
      var src = p.images[0].src;
      img.src = src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=360';
      img.alt = p.title;
      img.loading = 'lazy';
      img.draggable = false;
      a.appendChild(img);
      collage.appendChild(a);
      return a;
    });
    var dots = document.createElement('div');
    dots.className = 'gft-hero__dots';
    dots.setAttribute('aria-hidden', 'true');
    cards.forEach(function () { dots.appendChild(document.createElement('span')); });
    collage.appendChild(dots);

    function layout() {
      cards.forEach(function (a, i) {
        var rel = (i - front + n) % n; // 0 = front, 1 = right, 2 = left
        a.className = 'gft-hero__pic gft-hero__pic--' + (rel === 0 ? 2 : rel === 1 ? 3 : 1);
      });
      Array.prototype.forEach.call(dots.children, function (d, i) {
        d.classList.toggle('is-on', i === front);
      });
    }
    function go(step) {
      front = (front + step + n) % n;
      layout();
    }
    layout();

    var phone = window.matchMedia('(max-width: 749px)');
    var sx = 0;
    var sy = 0;
    var swiped = false;
    var timer = null;
    var stopAuto = function () { if (timer) { clearInterval(timer); timer = null; } };
    collage.addEventListener('touchstart', function (e) {
      stopAuto();
      sx = e.touches[0].clientX;
      sy = e.touches[0].clientY;
      swiped = false;
    }, { passive: true });
    collage.addEventListener('touchend', function (e) {
      var dx = e.changedTouches[0].clientX - sx;
      var dy = e.changedTouches[0].clientY - sy;
      if (Math.abs(dx) > 25 && Math.abs(dx) > Math.abs(dy)) {
        swiped = true;
        go(dx < 0 ? 1 : -1);
      }
    }, { passive: true });
    collage.addEventListener('click', function (e) {
      var a = e.target.closest('a');
      if (swiped) { e.preventDefault(); swiped = false; return; }
      // On phones a tap on a back photo brings it to the front first
      if (a && phone.matches && cards.indexOf(a) !== front) {
        e.preventDefault();
        stopAuto();
        front = cards.indexOf(a);
        layout();
      }
    });
    // Gentle hint on phones that the photos move; stops as soon as the shopper touches them
    var calm = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (phone.matches && !calm) {
      timer = setInterval(function () { go(1); }, 3500);
      setTimeout(stopAuto, 20000);
    }
  }

  /* Collection page header */
  function enhanceCollectionHero() {
    var hero = document.querySelector('.collection-hero');
    if (!hero || hero.classList.contains('gft-hero')) return;
    var wrap = hero.querySelector('.collection-hero__text-wrapper');
    var title = hero.querySelector('.collection-hero__title');
    var inner = hero.querySelector('.collection-hero__inner');
    if (!wrap || !title || !inner) return;
    hero.classList.add('gft-hero');
    var handle = currentHandle();
    var titleCopy = title.cloneNode(true);
    titleCopy.querySelectorAll('.visually-hidden').forEach(function (n) { n.remove(); }); // drop hidden "Collection:" label
    var name = clean(titleCopy.textContent);
    var groups = menuGroups();

    var crumbs = document.createElement('nav');
    crumbs.className = 'gft-crumbs';
    crumbs.setAttribute('aria-label', 'Breadcrumb');
    crumbs.innerHTML = '<a href="/">Home</a><span aria-hidden="true">›</span><a href="/collections">Collections</a><span aria-hidden="true">›</span><span class="gft-crumbs__current"></span>';
    crumbs.querySelector('.gft-crumbs__current').textContent = name;
    wrap.insertBefore(crumbs, wrap.firstChild);

    var rel = relatedFor(handle, groups, null);
    if (rel.group) {
      var tag = document.createElement('span');
      tag.className = 'gft-hero__group';
      tag.textContent = niceGroup(rel.group.title);
      wrap.insertBefore(tag, title);
    }

    var desc = hero.querySelector('.collection-hero__description');
    if (!desc || !clean(desc.textContent)) {
      var sub = document.createElement('p');
      sub.className = 'gft-hero__sub';
      sub.textContent = introFor(handle, name, rel.group);
      title.parentNode.insertBefore(sub, title.nextSibling);
    }

    // Group label, title and intro sit together so the photo stack can sit beside them on phones
    var head = document.createElement('div');
    head.className = 'gft-hero__head';
    var headText = document.createElement('div');
    headText.className = 'gft-hero__head-text';
    head.appendChild(headText);
    wrap.insertBefore(head, wrap.querySelector('.gft-hero__group') || title);
    [wrap.querySelector(':scope > .gft-hero__group'), title,
      wrap.querySelector(':scope > .gft-hero__sub, :scope > .collection-hero__description')
    ].forEach(function (n) { if (n && n.parentNode === wrap) headText.appendChild(n); });

    var stats = document.createElement('ul');
    stats.className = 'gft-hero__stats';
    wrap.appendChild(stats);

    var chipsHolder = document.createElement('div');
    wrap.appendChild(chipsHolder);

    var collage = document.createElement('div');
    collage.className = 'gft-hero__collage';
    // Desktop / tablet: photos float on the right of the card. Phones: next to the title.
    var phone = window.matchMedia('(max-width: 749px)');
    var placeCollage = function () {
      if (collage.dataset.gone) return;
      var box = phone.matches ? head : inner;
      if (collage.parentNode !== box) box.appendChild(collage);
    };
    placeCollage();
    if (phone.addEventListener) phone.addEventListener('change', placeCollage);

    // Real numbers for this collection: count, starting price, best discount, preview images
    getJSON('/collections/' + handle + '/products.json?limit=250').then(function (data) {
      var products = (data && data.products) || [];
      if (!products.length) { collage.dataset.gone = '1'; collage.remove(); stats.remove(); return; }
      var min = Infinity;
      var best = 0;
      var custom = 0;
      products.forEach(function (p) {
        (p.variants || []).forEach(function (v) {
          var price = parseFloat(v.price);
          var mrp = parseFloat(v.compare_at_price);
          if (price < min) min = price;
          if (mrp > price) best = Math.max(best, Math.round((1 - price / mrp) * 100));
        });
        if (/personali[sz]ed|custom/i.test(p.title + ' ' + (p.tags || []).join(' '))) custom++;
      });
      var html = '<li>' + svg(ICON_BOX) + '<strong>' + products.length + '</strong> ' + (products.length === 1 ? 'gift' : 'gifts') + '</li>';
      if (isFinite(min)) html += '<li>' + svg(ICON_TAG) + 'From <strong>Rs. ' + Math.round(min).toLocaleString('en-IN') + '</strong></li>';
      if (best >= 5) html += '<li class="gft-hero__stat--hot">' + svg(ICON_SPARK) + 'Up to <strong>' + best + '% off</strong></li>';
      if (custom && custom === products.length) html += '<li>' + svg(ICON_GIFT) + 'All personalised</li>';
      stats.innerHTML = html;

      var pics = products.filter(function (p) { return p.images && p.images[0]; }).slice(0, 3);
      if (pics.length < 2) { collage.dataset.gone = '1'; collage.remove(); return; }
      photoStack(collage, pics);
      hero.classList.add('gft-hero--has-collage');
    });

    countsMap().then(function (counts) {
      quickPicks(handle, name, groups, counts, chipsHolder);
    });
  }

  /* Quick picks: hand-picked keywords for each collection ("For Mom", "For Dad", "Birthday" ...).
     Clicking one keeps the shopper on this collection and brings the matching gifts to the top.
     A product matches a keyword when it carries the keyword's tag (e.g. "for-mom").
     Until products are tagged, the store's own relation / occasion / profession
     collections are used instead (e.g. "For Mom" = gifts also in Mother / Father). */
  var PICK_KEYWORDS = {
    mom: { label: 'For Mom', tag: 'for-mom', from: 'mother-father' },
    dad: { label: 'For Dad', tag: 'for-dad', from: 'mother-father' },
    parents: { label: 'For Parents', tag: 'for-parents', from: 'mother-father' },
    husband: { label: 'For Husband', tag: 'for-husband', from: 'husband-wife' },
    wife: { label: 'For Wife', tag: 'for-wife', from: 'husband-wife' },
    couple: { label: 'For Couples', tag: 'for-couple', from: 'husband-wife' },
    brother: { label: 'For Brother', tag: 'for-brother', from: 'brother-sister' },
    sister: { label: 'For Sister', tag: 'for-sister', from: 'brother-sister' },
    son: { label: 'For Son', tag: 'for-son', from: 'son-daughter' },
    daughter: { label: 'For Daughter', tag: 'for-daughter', from: 'son-daughter' },
    boyfriend: { label: 'For Boyfriend', tag: 'for-boyfriend', from: 'boyfriend-girlfriend' },
    girlfriend: { label: 'For Girlfriend', tag: 'for-girlfriend', from: 'boyfriend-girlfriend' },
    friend: { label: 'For Friend', tag: 'for-friend', from: 'friend-boss-colleagues' },
    boss: { label: 'For Boss', tag: 'for-boss', from: 'friend-boss-colleagues' },
    colleague: { label: 'For Colleague', tag: 'for-colleague', from: 'friend-boss-colleagues' },
    teacher: { label: 'For Teacher', tag: 'for-teacher', from: 'teachers' },
    employees: { label: 'For Employees', tag: 'for-employees', from: 'employ-gifts' },
    clients: { label: 'For Clients', tag: 'for-clients', from: 'clint-gifts' },
    birthday: { label: 'Birthday', tag: 'birthday', from: 'birthday', occasion: true },
    anniversary: { label: 'Anniversary', tag: 'anniversary', from: 'anniversary', occasion: true },
    wedding: { label: 'Wedding', tag: 'wedding', from: 'wedding', occasion: true },
    housewarming: { label: 'Housewarming', tag: 'housewarming', from: 'housewarming', occasion: true },
    farewell: { label: 'Farewell', tag: 'farewell', from: 'farewell-retirement', occasion: true },
    retirement: { label: 'Retirement', tag: 'retirement', from: 'farewell-retirement', occasion: true },
    festivals: { label: 'Festivals', tag: 'festival', from: 'festival-gifts', occasion: true }
  };
  var WHO = 'Who is it for?';
  var WHEN = 'What is the occasion?';
  var PICKS_FOR = {
    // By occasion: who the shopper is buying for
    'birthday': [WHO, 'mom dad husband wife brother sister son daughter boyfriend girlfriend friend'],
    'anniversary': [WHO, 'wife husband parents'],
    'wedding': [WHO, 'couple parents'],
    'housewarming': [WHO, 'parents friend colleague boss brother sister'],
    'farewell-retirement': [WHO, 'boss colleague friend teacher dad mom'],
    'festivals': [WHO, 'parents brother sister friend employees clients'],
    // By relation: the occasion
    'mother-father': [WHEN, 'birthday anniversary housewarming retirement festivals'],
    'husband-wife': [WHEN, 'anniversary birthday wedding housewarming festivals'],
    'brother-sister': [WHEN, 'birthday housewarming farewell festivals'],
    'son-daughter': [WHEN, 'birthday housewarming farewell festivals'],
    'boyfriend-girlfriend': [WHEN, 'birthday anniversary farewell festivals'],
    'friend-boss-colleagues': [WHEN, 'birthday farewell housewarming festivals'],
    // By profession: the occasion
    'doctor': [WHEN, 'birthday farewell housewarming festivals'],
    'it-professional': [WHEN, 'birthday farewell housewarming festivals'],
    'teachers': [WHEN, 'birthday farewell festivals'],
    'lawyers': [WHEN, 'birthday farewell housewarming festivals'],
    'engineers': [WHEN, 'birthday farewell housewarming festivals'],
    'other-professionals': [WHEN, 'birthday farewell housewarming festivals'],
    // Home & decor
    'home-accessories': [WHO, 'parents couple brother sister friend housewarming'],
    // Corporate
    'employ-gifts': [WHEN, 'birthday farewell festivals'],
    'clint-gifts': [WHEN, 'festivals housewarming'],
    'festival-gifts': [WHO, 'employees clients parents brother sister friend'],
    // All products
    'all': [WHO, 'mom dad husband wife brother sister son daughter friend teacher']
  };
  // Collections that are not listed above get a list based on their menu group
  var PICKS_BY_GROUP = {
    occasion: [WHO, 'mom dad husband wife brother sister son daughter friend'],
    relation: [WHEN, 'birthday anniversary housewarming farewell festivals'],
    profession: [WHEN, 'birthday farewell housewarming festivals'],
    other: [WHO, 'parents couple brother sister son daughter friend']
  };
  function groupType(g) {
    if (!g) return 'other';
    if (/relation/i.test(g.title)) return 'relation';
    if (/occasion/i.test(g.title)) return 'occasion';
    if (/profession/i.test(g.title)) return 'profession';
    return 'other';
  }
  function cardHandle(li) {
    var a = li.querySelector('a[href*="/products/"]');
    var m = a && a.getAttribute('href').match(/\/products\/([^\/?#]+)/);
    return m ? decodeURIComponent(m[1]) : '';
  }
  function productsOf(handle) {
    return getJSON('/collections/' + handle + '/products.json?limit=250').then(function (d) {
      return (d && d.products) || [];
    });
  }

  function quickPicks(handle, name, groups, counts, holder) {
    var plan = PICKS_FOR[handle];
    if (!plan) {
      var own = null;
      groups.some(function (g) {
        if (g.items.some(function (it) { return it.handle === handle; })) { own = g; return true; }
        return false;
      });
      plan = PICKS_BY_GROUP[groupType(own)];
    }
    var keys = plan[1].split(' ').filter(function (k) {
      var kw = PICK_KEYWORDS[k];
      return kw && kw.from !== handle && counts[kw.from] !== 0;
    });
    var fallback = function () {
      var r = relatedFor(handle, groups, counts);
      if (r.items.length) holder.appendChild(chipRow(r.label, r.items.slice(0, 8)));
    };
    if (!keys.length) { fallback(); return; }

    var sources = {};
    keys.forEach(function (k) { sources[PICK_KEYWORDS[k].from] = 1; });
    var list = Object.keys(sources);
    Promise.all([productsOf(handle)].concat(list.map(productsOf))).then(function (res) {
      var mine = res[0];
      var ownSet = {};
      mine.forEach(function (p) { ownSet[p.handle] = 1; });
      var byCollection = {};
      list.forEach(function (h, i) {
        var set = {};
        res[i + 1].forEach(function (p) { if (ownSet[p.handle]) set[p.handle] = 1; });
        byCollection[h] = set;
      });
      var picks = [];
      keys.forEach(function (k) {
        var kw = PICK_KEYWORDS[k];
        // Products tagged for this keyword win over the collection match
        var tagged = {};
        var n = 0;
        mine.forEach(function (p) {
          var tags = (p.tags || []).map(function (t) { return String(t).toLowerCase(); });
          if (tags.indexOf(kw.tag) > -1) { tagged[p.handle] = 1; n++; }
        });
        var set = n ? tagged : byCollection[kw.from];
        if (!n) n = Object.keys(set).length;
        if (n) picks.push({ label: kw.label, type: kw.occasion ? 'occasion' : 'relation', set: set, n: n });
      });
      if (!picks.length) { fallback(); return; }
      holder.appendChild(pickRow(picks, plan[0], name));
    });
  }

  function pickRow(picks, heading, name) {
    var row = document.createElement('div');
    row.className = 'gft-coll-chips gft-picks';
    var lab = document.createElement('span');
    lab.className = 'gft-coll-chips__label';
    lab.textContent = heading;
    var track = document.createElement('div');
    track.className = 'gft-coll-chips__track';

    var state = { grid: null, original: null };
    var buttons = [];
    var make = function (text, n, pick) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'gft-chip gft-pick';
      b.textContent = text;
      if (n) {
        var c = document.createElement('span');
        c.className = 'gft-pick__n';
        c.textContent = n;
        b.appendChild(c);
      }
      b.setAttribute('aria-pressed', pick ? 'false' : 'true');
      if (!pick) b.classList.add('is-active');
      b.addEventListener('click', function () { apply(pick, b); });
      buttons.push(b);
      track.appendChild(b);
    };
    make('All gifts', 0, null);
    picks.forEach(function (p) { make(p.label, p.n, p); });

    function currentGrid() {
      var g = document.getElementById('product-grid');
      if (g !== state.grid) {
        state.grid = g;
        state.original = g ? Array.prototype.slice.call(g.children) : [];
      }
      return g;
    }
    function apply(pick, btn) {
      var grid = currentGrid();
      if (!grid) return;
      buttons.forEach(function (b) {
        var on = b === btn;
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      grid.querySelectorAll('.gft-pick-divider, .gft-pick-head').forEach(function (n) { n.remove(); });
      if (!pick) {
        state.original.forEach(function (li) { grid.appendChild(li); });
        return;
      }
      var cards = state.original.filter(function (li) { return li.tagName === 'LI'; });
      var hits = cards.filter(function (li) { return pick.set[cardHandle(li)]; });
      var rest = cards.filter(function (li) { return !pick.set[cardHandle(li)]; });
      var word = hits.length === 1 ? 'gift' : 'gifts';
      var head = document.createElement('li');
      head.className = 'gft-pick-head';
      var txt = document.createElement('span');
      txt.textContent = pick.type === 'occasion'
        ? hits.length + ' ' + pick.label + ' ' + word
        : hits.length + ' ' + word + ' ' + pick.label.replace(/^For /, 'for ');
      var clear = document.createElement('button');
      clear.type = 'button';
      clear.className = 'gft-pick-head__clear';
      clear.textContent = 'Show all \u00d7';
      clear.addEventListener('click', function () { apply(null, buttons[0]); });
      head.appendChild(txt);
      head.appendChild(clear);
      grid.appendChild(head);
      hits.forEach(function (li) { grid.appendChild(li); });
      if (rest.length) {
        var div = document.createElement('li');
        div.className = 'gft-pick-divider';
        div.setAttribute('aria-hidden', 'true');
        div.textContent = 'More ' + name + ' gifts';
        grid.appendChild(div);
        rest.forEach(function (li) { grid.appendChild(li); });
      }
      var box = document.getElementById('ProductGridContainer') || grid;
      var top = box.getBoundingClientRect().top + window.pageYOffset - 120;
      window.scrollTo({ top: top, behavior: 'smooth' });
    }

    // Filters / sorting rebuild the grid: go back to "All gifts"
    var container = document.getElementById('ProductGridContainer');
    if (container && 'MutationObserver' in window) {
      new MutationObserver(function () {
        if (document.getElementById('product-grid') !== state.grid && state.grid) {
          state.grid = null;
          buttons.forEach(function (b, i) {
            b.classList.toggle('is-active', i === 0);
            b.setAttribute('aria-pressed', i === 0 ? 'true' : 'false');
          });
        }
      }).observe(container, { childList: true });
    }

    // Long rows on phones: show the first few chips and a "+N more" button (CSS hides the rest)
    if (buttons.length > 7) {
      row.classList.add('gft-picks--long');
      var more = document.createElement('button');
      more.type = 'button';
      more.className = 'gft-chip gft-picks__more';
      more.textContent = '+' + (buttons.length - 6) + ' more';
      more.addEventListener('click', function () { row.classList.add('is-open'); });
      track.appendChild(more);
    }

    row.appendChild(lab);
    row.appendChild(track);
    return row;
  }

  /* Friendly message when a collection has no products (or filters match nothing) */
  function enhanceEmptyCollection() {
    var empty = document.querySelector('.collection--empty');
    if (!empty || empty.querySelector('.gft-coll-empty')) return;
    var filtered = /[?&]filter\./.test(location.search);
    var box = document.createElement('div');
    box.className = 'gft-coll-empty';
    box.innerHTML =
      '<div class="gft-empty__icon">' + svg(ICON_GIFT) + '</div>' +
      '<h2 class="gft-coll-empty__title"></h2><p class="gft-coll-empty__text"></p>';
    box.querySelector('.gft-coll-empty__title').textContent = filtered ? 'No gifts match these filters' : 'New gifts are on their way';
    box.querySelector('.gft-coll-empty__text').textContent = filtered
      ? 'Try removing a filter or two to see more options.'
      : 'We are handcrafting new pieces for this collection. Meanwhile, explore these:';
    if (filtered) {
      var clear = document.createElement('a');
      clear.className = 'gft-btn';
      clear.href = location.pathname;
      clear.textContent = 'Clear all filters';
      box.appendChild(clear);
    }
    var old = empty.querySelector('.title-wrapper');
    if (old) old.style.display = 'none';
    empty.appendChild(box);
    countsMap().then(function (counts) {
      var r = relatedFor(currentHandle(), menuGroups(), counts);
      if (r.items.length) box.appendChild(chipRow(r.label, r.items));
    });
  }

  /* /collections – header, product counts, hide empty/internal collections */
  function enhanceCollectionsList() {
    if (!/^\/collections\/?$/.test(location.pathname)) return;
    var list = document.querySelector('.collection-list');
    if (!list || list.dataset.gftDone) return;
    list.dataset.gftDone = '1';
    var page = list.closest('.page-width');
    var h1 = page && page.querySelector('h1.title');
    if (h1 && !page.querySelector('.gft-list-head')) {
      var head = document.createElement('div');
      head.className = 'gft-list-head';
      head.innerHTML = '<span class="gft-list-head__eyebrow">Shop by collection</span>';
      h1.parentNode.insertBefore(head, h1);
      head.appendChild(h1);
      var p = document.createElement('p');
      p.className = 'gft-list-head__sub';
      p.textContent = 'Find the perfect personalised gift for every person and every occasion.';
      head.appendChild(p);
    }
    countsMap().then(function (counts) {
      list.querySelectorAll('.collection-list__item').forEach(function (li) {
        var a = li.querySelector('a[href*="/collections/"]');
        if (!a) return;
        var handle = decodeURIComponent(a.getAttribute('href').split('/collections/')[1].split(/[?#\/]/)[0]);
        var n = counts[handle];
        if (INTERNAL.test(handle) || n === 0) {
          li.style.display = 'none';
          return;
        }
        if (n && !li.querySelector('.gft-count')) {
          var pill = document.createElement('span');
          pill.className = 'gft-count';
          pill.textContent = n + (n === 1 ? ' gift' : ' gifts');
          var info = li.querySelectorAll('.card__information');
          (info[info.length - 1] || li).appendChild(pill);
        }
      });
    });
  }

  function run() {
    enhanceCollectionHero();
    enhanceEmptyCollection();
    enhanceCollectionsList();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
  // Filters re-render the product grid; re-check the empty state afterwards
  var grid = document.getElementById('ProductGridContainer');
  if (grid && 'MutationObserver' in window) {
    var t;
    new MutationObserver(function () {
      clearTimeout(t);
      t = setTimeout(enhanceEmptyCollection, 150);
    }).observe(grid, { childList: true, subtree: true });
  }
})();

/* Giftationery – small title above single-level dropdowns (Home & Decor, Corporate Gifting) */
(function () {
  function decorate() {
    document.querySelectorAll('.header__inline-menu details').forEach(function (d) {
      var inner = d.querySelector('.mega-menu__inner');
      var list = inner && inner.querySelector('.mega-menu__list--condensed');
      if (!list || inner.querySelector('.gft-menu-head')) return;
      var head = document.createElement('div');
      head.className = 'gft-menu-head';
      head.textContent = (d.querySelector('summary').textContent || '').replace(/\s+/g, ' ').trim();
      inner.insertBefore(head, list);
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', decorate);
  } else {
    decorate();
  }
})();

/* Giftationery – menu labels typed in capitals (e.g. "HOME & DECOR") are shown in title case like the rest */
(function () {
  function titleCase() {
    document.querySelectorAll('.header__inline-menu .list-menu--inline > li .header__menu-item > span').forEach(function (s) {
      var t = s.textContent.trim();
      if (!t || t !== t.toUpperCase() || !/[A-Z]{2}/.test(t)) return;
      var nice = t.toLowerCase().replace(/(^|[\s\/&-])([a-z])/g, function (m, p, c) { return p + c.toUpperCase(); });
      if (s.textContent !== nice) s.textContent = nice;
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', titleCase);
  } else {
    titleCase();
  }
})();

/* Giftationery – search: friendlier placeholder everywhere + a clearer header on the search results page */
(function () {
  var PLACEHOLDER = 'Search gifts, names, occasions…';
  var POPULAR = ['LED Lamp', 'Name Plate', 'Caricature', 'Desk Organizer', 'Pen Stand', 'Coaster'];

  function placeholders() {
    document.querySelectorAll('input.search__input').forEach(function (i) {
      if (i.placeholder !== PLACEHOLDER) i.placeholder = PLACEHOLDER;
      if (!i.getAttribute('aria-label')) i.setAttribute('aria-label', 'Search');
    });
  }

  function searchPage() {
    var head = document.querySelector('.template-search__header');
    if (!head || head.dataset.gftDone) return;
    head.dataset.gftDone = '1';
    var q = (new URLSearchParams(location.search).get('q') || '').trim();
    var h1 = head.querySelector('h1');
    var status = head.querySelector('p[role="status"]');

    var eyebrow = document.createElement('p');
    eyebrow.className = 'gft-search-eyebrow';
    eyebrow.textContent = 'Search';
    if (h1) {
      head.insertBefore(eyebrow, h1);
      if (!q) h1.textContent = 'What are you looking for?';
      else h1.textContent = (status ? 'No results for “' : 'Results for “') + q + '”';
    }

    var sub = document.createElement('p');
    sub.className = 'gft-search-sub';
    if (!q) {
      sub.textContent = 'Find the perfect personalised gift for every person and occasion.';
    } else if (!status) {
      var countEl = document.getElementById('ProductCountDesktop') || document.getElementById('ProductCount');
      var n = countEl ? (countEl.textContent.match(/\d+/) || [''])[0] : '';
      if (n) {
        var strong = document.createElement('strong');
        strong.textContent = n;
        sub.appendChild(strong);
        sub.appendChild(document.createTextNode(n === '1' ? ' gift matches your search' : ' gifts match your search'));
      }
    }
    if (sub.textContent && h1) h1.insertAdjacentElement('afterend', sub);
    if (status) {
      status.classList.add('gft-search-empty');
      status.textContent = 'Check the spelling, or try one of these popular searches.';
    }

    var row = document.createElement('div');
    row.className = 'gft-search-popular';
    var label = document.createElement('span');
    label.className = 'gft-search-popular__label';
    label.textContent = status ? 'Try these:' : 'Popular:';
    row.appendChild(label);
    POPULAR.forEach(function (term) {
      if (term.toLowerCase() === q.toLowerCase()) return;
      var a = document.createElement('a');
      a.className = 'gft-chip';
      a.href = '/search?q=' + encodeURIComponent(term);
      a.textContent = term;
      row.appendChild(a);
    });
    head.appendChild(row);
  }

  function run() {
    placeholders();
    searchPage();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();

/* Giftationery – product page on phones: the name reads first, then the photos,
   the way a marketplace listing is laid out. Also makes the bulk enquiry
   gallery thumbnails switch the main picture. */
(function () {
  var phone = window.matchMedia('(max-width: 749px)');

  /* Move the title block above the photos on phones, and back again on wider screens */
  function titleFirst() {
    var sets = [
      { media: '.product__media-wrapper', info: '.product__info-container', take: ':scope > .product__title' },
      { media: '.bep-gallery', info: '.bep-info', take: ':scope > .bep-badge, :scope > .bep-title' }
    ];
    var moves = [];
    sets.forEach(function (set) {
      var media = document.querySelector(set.media);
      var info = document.querySelector(set.info);
      if (!media || !info) return;
      info.querySelectorAll(set.take).forEach(function (el) {
        var mark = document.createComment('gft-pdp');
        el.parentNode.insertBefore(mark, el);
        moves.push({ el: el, mark: mark, media: media });
      });
    });
    if (!moves.length) return;

    var onTop = false;
    function arrange() {
      if (phone.matches === onTop) return;
      onTop = phone.matches;
      moves.forEach(function (m) {
        if (onTop) {
          m.el.classList.add('gft-pdp-top');
          m.media.parentNode.insertBefore(m.el, m.media);
        } else {
          m.el.classList.remove('gft-pdp-top');
          m.mark.parentNode.insertBefore(m.el, m.mark);
        }
      });
    }
    arrange();
    if (phone.addEventListener) phone.addEventListener('change', arrange);
  }

  /* Bulk enquiry gallery: tapping a thumbnail shows that photo */
  function bulkThumbs() {
    var main = document.querySelector('.bep-main-img img');
    var thumbs = document.querySelectorAll('.bep-thumb');
    if (!main || !thumbs.length) return;
    thumbs.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var full = btn.getAttribute('data-full');
        if (!full) return;
        main.removeAttribute('srcset');
        main.removeAttribute('sizes');
        main.src = full;
        main.alt = btn.getAttribute('data-alt') || '';
        thumbs.forEach(function (t) { t.removeAttribute('aria-current'); });
        btn.setAttribute('aria-current', 'true');
      });
    });
  }

  function start() {
    titleFirst();
    bulkThumbs();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();

/* Giftationery - on phones and tablets the Shop dropdown sections (By Relation, By Occasion,
   By Profession) fold up like an accordion. The section holding the current page opens first. */
(function () {
  var mq = window.matchMedia('(max-width: 989px)');

  function head(li) {
    return li.querySelector(':scope > .mega-menu__link--level-2');
  }

  function setup(det) {
    if (det.dataset.gftAcc) return;
    det.dataset.gftAcc = '1';
    var items = [].slice.call(det.querySelectorAll('.mega-menu__list > li')).filter(function (li) {
      return li.querySelector(':scope > ul') && head(li);
    });
    if (items.length < 2) return;

    items.forEach(function (li) {
      li.classList.add('gft-acc');
      var h = head(li);
      h.setAttribute('aria-expanded', 'false');
      h.addEventListener('click', function (e) {
        if (!mq.matches) return;
        e.preventDefault();
        var wasOpen = li.classList.contains('is-open');
        items.forEach(function (x) {
          x.classList.remove('is-open');
          head(x).setAttribute('aria-expanded', 'false');
        });
        if (!wasOpen) {
          li.classList.add('is-open');
          h.setAttribute('aria-expanded', 'true');
        }
      });
    });

    var first = items.filter(function (li) {
      return li.querySelector('.mega-menu__link--active');
    })[0] || items[0];
    first.classList.add('is-open');
    head(first).setAttribute('aria-expanded', 'true');
  }

  function start() {
    document.querySelectorAll('.header__inline-menu details').forEach(setup);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();

/* Giftationery - home collection carousel on phones: the strip scrolls natively, so make sure it
   starts at the first card (the section script moves its own offset, not the scroll position).
   Stops as soon as the shopper touches the strip. */
(function () {
  var mq = window.matchMedia('(max-width: 749px)');

  function setup() {
    var track = document.querySelector('.collection-carousel-track');
    if (!track || track.dataset.gftStart) return;
    track.dataset.gftStart = '1';
    var touched = false;
    ['touchstart', 'pointerdown', 'wheel', 'keydown'].forEach(function (name) {
      track.addEventListener(name, function () { touched = true; }, { passive: true });
    });
    function reset() {
      if (!touched && mq.matches && track.scrollLeft > 0) track.scrollLeft = 0;
    }
    [0, 300, 900, 1800, 3200].forEach(function (ms) { setTimeout(reset, ms); });
    window.addEventListener('load', reset);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setup);
  } else {
    setup();
  }
})();


/* Mobile filter drawer: keep every filter group open so all options show in one panel. */
(function () {
  var mq = window.matchMedia('(max-width: 749px)');
  function openAll() {
    if (!mq.matches) return;
    document.querySelectorAll('.mobile-facets__details').forEach(function (d) {
      if (!d.open) d.open = true;
    });
  }
  openAll();
  document.addEventListener('DOMContentLoaded', openAll);
  new MutationObserver(openAll).observe(document.documentElement, { childList: true, subtree: true });
  if (mq.addEventListener) mq.addEventListener('change', openAll);
})();


/* Home collection carousel on phones: slide to the next card on its own, and stop while the shopper is touching it.
   Controlled from the theme customizer (Collection carousel > Enable autoplay / Autoplay speed). */
(function () {
  var mq = window.matchMedia('(max-width: 749px)');
  function setup() {
    var track = document.querySelector('.collection-carousel-track');
    if (!track || track.dataset.gftAuto) return;
    track.dataset.gftAuto = '1';
    var box = track.closest('.collection-carousel-container');
    var on = !box || box.getAttribute('data-autoplay') !== 'false';
    var secs = box ? parseFloat(box.getAttribute('data-autoplay-speed')) : NaN;
    if (!(secs > 0)) secs = 4;
    if (!on) return;
    var paused = false, visible = false, resumeTimer = null;
    function holdOff() { paused = true; clearTimeout(resumeTimer); resumeTimer = setTimeout(function () { paused = false; }, 7000); }
    ['touchstart', 'pointerdown', 'wheel', 'keydown'].forEach(function (name) { track.addEventListener(name, holdOff, { passive: true }); });
    if ('IntersectionObserver' in window) { new IntersectionObserver(function (entries) { visible = entries[0].isIntersecting; }, { threshold: 0.4 }).observe(track); } else { visible = true; }
    function step() {
      if (!mq.matches || paused || !visible || document.hidden) return;
      var cards = track.querySelectorAll('.collection-card');
      if (cards.length < 2) return;
      var stepW = cards[1].getBoundingClientRect().left - cards[0].getBoundingClientRect().left;
      if (stepW <= 0) return;
      var max = track.scrollWidth - track.clientWidth;
      if (track.scrollLeft + stepW > max + 4) { track.scrollTo({ left: 0, behavior: 'smooth' }); }
      else { track.scrollTo({ left: track.scrollLeft + stepW, behavior: 'smooth' }); }
    }
    setInterval(step, secs * 1000);
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', setup); } else { setup(); }
})();

/* Mobile top menu chips: an open dropdown (Shop, Home & Decor, ...) closes when the shopper swipes or scrolls away from it. */
(function () {
  var mq = window.matchMedia('(max-width: 749px)');
  var raf = 0, sx = 0, sy = 0, st = null;
  function openOnes() { return [].slice.call(document.querySelectorAll('.header__inline-menu details[open]')); }
  function closeIt(det) { var s = det.querySelector(':scope > summary'); if (s) { s.click(); } else { det.removeAttribute('open'); } }
  function checkScroll() {
    raf = 0;
    if (!mq.matches) return;
    openOnes().forEach(function (det) {
      var panel = det.querySelector('.mega-menu__content') || det;
      var r = panel.getBoundingClientRect();
      if (r.bottom < 40 || r.top > window.innerHeight - 40) closeIt(det);
    });
  }
  window.addEventListener('scroll', function () { if (!raf) raf = requestAnimationFrame(checkScroll); }, { passive: true });
  document.addEventListener('touchstart', function (e) { var t = e.touches[0]; sx = t.clientX; sy = t.clientY; st = e.target; }, { passive: true });
  document.addEventListener('touchmove', function (e) {
    if (!mq.matches || !st) return;
    var t = e.touches[0];
    if (Math.abs(t.clientY - sy) < 14 && Math.abs(t.clientX - sx) < 14) return;
    openOnes().forEach(function (det) { if (det.hasAttribute('open') && !det.contains(st)) closeIt(det); });
  }, { passive: true });
})();

/* Collection sort dropdown: custom pill-style list (desktop) */
(function(){
  function closeAll(){var o=document.querySelectorAll('.gft-sort.is-open');for(var i=0;i<o.length;i++){o[i].classList.remove('is-open');}}
  document.addEventListener('click',closeAll);
  document.addEventListener('keydown',function(e){if(e.key==='Escape'){closeAll();}});
  function build(){
    var sel=document.getElementById('SortBy');
    if(!sel||sel.getAttribute('data-gft-sort')){return;}
    var wrap=sel.closest('.select');
    if(!wrap){return;}
    sel.setAttribute('data-gft-sort','1');
    var box=document.createElement('div');box.className='gft-sort';
    var btn=document.createElement('button');btn.type='button';btn.className='gft-sort__btn';btn.setAttribute('aria-haspopup','listbox');
    var list=document.createElement('ul');list.className='gft-sort__list';list.setAttribute('role','listbox');
    function sync(){
      btn.textContent=sel.options[sel.selectedIndex].textContent.trim();
      for(var i=0;i<list.children.length;i++){list.children[i].classList.toggle('is-active',i===sel.selectedIndex);}
    }
    Array.prototype.forEach.call(sel.options,function(o,i){
      var li=document.createElement('li');li.setAttribute('role','option');li.textContent=o.textContent.trim();
      li.addEventListener('click',function(){sel.selectedIndex=i;sel.dispatchEvent(new Event('input',{bubbles:true}));box.classList.remove('is-open');sync();});
      list.appendChild(li);
    });
    btn.addEventListener('click',function(e){e.stopPropagation();box.classList.toggle('is-open');});
    box.appendChild(btn);box.appendChild(list);
    wrap.parentNode.insertBefore(box,wrap);
    wrap.classList.add('gft-sort-native');
    sync();
  }
  build();
  new MutationObserver(build).observe(document.body,{childList:true,subtree:true});
})();

/* Collection filters: close an open dropdown when clicking elsewhere or pressing Escape */
(function(){
  function closeOthers(target){
    var d=document.querySelectorAll('.facets__disclosure[open]');
    for(var i=0;i<d.length;i++){if(!d[i].contains(target)){d[i].removeAttribute('open');}}
    var s=document.querySelectorAll('.gft-sort.is-open');
    for(var j=0;j<s.length;j++){if(!s[j].contains(target)){s[j].classList.remove('is-open');}}
  }
  document.addEventListener('click',function(e){closeOthers(e.target);},true);
  document.addEventListener('keydown',function(e){
    if(e.key==='Escape'){closeOthers(document.body);}
  });
})();


/* Related products arrows: the section loads its list after page load, so its inline script never finds the slider. Use delegated handlers instead (CMT 2). */
(function(){
  function rpList(btn){var w=btn.closest('.related-products');return w?w.querySelector('.related-products__list'):null;}
  function rpUpdate(list){
    var w=list.closest('.related-products');if(!w)return;
    var p=w.querySelector('.related-products__nav-button--prev'),n=w.querySelector('.related-products__nav-button--next');
    if(!p||!n)return;
    var max=list.scrollWidth-list.clientWidth-2;
    p.disabled=list.scrollLeft<=0;
    n.disabled=list.scrollLeft>=max;
  }
  document.addEventListener('click',function(e){
    var b=e.target.closest?e.target.closest('.related-products__nav-button'):null;
    if(!b)return;
    var list=rpList(b);if(!list)return;
    var it=list.querySelector('.grid__item');
    var gap=parseFloat(getComputedStyle(list).gap)||0;
    var amt=it?it.getBoundingClientRect().width+gap:300;
    list.scrollBy({left:b.getAttribute('data-direction')==='prev'?-amt:amt,behavior:'smooth'});
  });
  document.addEventListener('scroll',function(e){
    var t=e.target;
    if(t&&t.classList&&t.classList.contains('related-products__list'))rpUpdate(t);
  },true);
  function rpInit(){
    var lists=document.querySelectorAll('.related-products__list');
    for(var i=0;i<lists.length;i++)rpUpdate(lists[i]);
  }
  window.addEventListener('resize',rpInit);
  new MutationObserver(rpInit).observe(document.body,{childList:true,subtree:true});
  rpInit();
})();
